import { DriverStatisticsType } from '@sky-it-livedata/livedata-sports-design-system';

export type DriverStatistics = {
  driverId: string;
  statistics: {
    customCompetitionName: string;
    customSeasonName: string;
    seasonAndCompId: string;
    stats: Array<{
      type: DriverStatisticsType;
      value: number;
    }>;
  };
};

export type DriverStatisticsQuery = {
  data: {
    getDriverStatsWidget: DriverStatistics;
  };
};

export const statsOrder: DriverStatisticsType[] = [
  'Ranking',
  'Points',
  'Races',
  'GpPoints',
  'Victories',
  'Podiums',
  'TopTen',
  'Poles',
  'FastestLaps',
  'Dnfs',
  'SprintRaces',
  'SprintPoints',
  'SprintVictories',
  'SprintPodiums',
  'SprintPoles',
  'SprintTopTen',
];